import { createAppTestIds } from './index';

/**
 * Test IDs for Google Docs integration
 */
export const GOOGLE_DOCS_TEST_IDS = {
  ...createAppTestIds('google-docs'),
} as const;
